export const standardCode =
`
  <Footer
    copyright={'Airtel India © 2018 –– All Rights Reserved.'}
    support={'support link'}
  />
`;

export const productLandingCode =
`
  <Footer
    layout={'plp'}
    mainLinks={[
      {
        title: 'Help center',
        href: '/help'
      },
      {
        title: 'Visit Airtel.in',
        href: '/visit'
      },
      {
        title: 'Client area',
        href: '/visit'
      }
    ]}
    socialLinks={social_links}
  />
`;

export const standardLandingCode =
`
  <Footer
    layout={'slp'}
    mainLinks={main_links}
    sectionLinks={section_links}
    socialLinks={social_links}
    siteLinks={site_links}
  />
`;






// WEBPACK FOOTER //
// ./src/containers/components/Footer/constants/footersCode.js